import VueIziToast from 'vue-izitoast';

export default {
  success(message, title = '', options = {}) {
    new VueIziToast()._izi.success(Object.assign({}, options, { message, title }));
  },

  info(message, title = '', options = {}) {
    new VueIziToast()._izi.info(Object.assign({}, options, { message, title }));
  },

  error(message, title = '', options = {}) {
    new VueIziToast()._izi.error(Object.assign({}, options, { message, title }));
  },

  warning(message, title = '', options = {}) {
    new VueIziToast()._izi.warning(Object.assign({}, options, { message, title }));
  },

  question(message, title = '', options = {}) {
    new VueIziToast()._izi.question(Object.assign({}, options, { message, title }));
  },

  progress(message, title = '', options = {}) {
    new VueIziToast()._izi.progress(Object.assign({}, options, { message, title }));
  }
};
